import * as ng from 'angular';
import { ContainerBottomReachedOnScroll } from './container-bottom-rached-on-scroll.directive';


export const ContainerBottomReachedOnScrollModule: string =
    ng.module('container-bottom-rached-on-scroll', [
    ])
        .directive('containerBottomReachedOnScroll', ContainerBottomReachedOnScroll)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/container-bottom-rached-on-scroll/container-bottom-rached-on-scroll.module.ts